<template>
  <div>
      <section class="xlrclh">
          <img class="top-img" src="./../assets/imgs/133/base.png" alt="" />
          <div class="technological-process">
              <div class="rhtj mar-t2">
                  <img
                      class="top"
                      src="./../assets/imgs/xllh/rcgyysq_zcjj.png"
                      alt=""
                  />
                  <div class="content">
                    围绕区（市）县农业主导产业和特色优势产业发展需求，结合“天府粮仓”成都片区建设的现实需要，以提升科技支撑能力和产业发展水平为目的，以在蓉国家、省市涉农科研机构专家人才、农业科技推广人才和乡村“土专家”“田秀才”等各类人才为支撑，组建17个农业科技专家服务团，组团式对应服务17个涉农区（市）县，采取“一对一”、点对点等方式提供农业科技服务，打造示范基地，培育科技服务人才，推动新品种、新技术、新装备和新模式在成都转化应用。
                  </div>
              </div>
              <div class="zccl" >
                  <img
                      class="top"
                      src="./../assets/imgs/133/title1.png"
                      alt=""
                  />
                  <div class="content" style="background-color: #fff;">
                    17个涉农区（市）县农业农村部门会同对应的首席专家，筛选在蓉涉农科研院校所专家、市县农技推广人才、乡村“土专家”“田秀才”、新型农业经营主体等各类人才，分别组建1个农业科技专家服务团，面向区（市）县域范围内的涉农企业、农民专业合作社、家庭农场、种植（养殖）大户以及涉农协会等，深入农业园区、示范基地以及田间地头，开展农业决策咨询、技术指导、创新攻关、试验示范、推广应用、观摩培训、农资推介、病虫害诊断、品牌创建、人才培育、政策宣传等服务。
                  </div>
              </div>
              <div class="zccl">
                  <img
                      class="top"
                      src="./../assets/imgs/133/title2.png"
                      alt=""
                  />
                  <div class="content">
                      <div class="des">
                          <div class="title">一、组建农业科技专家服务团</div>
                          <div >
                            17个涉农区（市）县分别组建1个由首席专家、骨干专家、市县农技推广人才、乡村“土专家”“田秀才”、新型农业经营主体等组成的农业科技专家服务团，团队成员不少于5人（其中地方农技推广人员和新型农业经营主体分别不少于1人）。
                          </div>
                      </div>
                      <div class="des">
                          <div class="title">二、建立协同工作机制</div>
                          <div >
                            每个农业科技专家服务团成立1个工作组，由区（市）县农业农村部门分管负责同志和团队首席任双组长，成员包括区（市）县农业农村部门相关科室负责人、团队成员、示范的新型农业经营主体和农户等，建立日常工作联系机制，协同推进相关工作。
                          </div>
                      </div>
                      <div class="des">
                          <div class="title">三、开展技术创新和推广服务</div>
                          <div >
                            开展技术创新和推广服务。通过实地调研，围绕本地主导产业发展和新型农业经营主体的技术需求，确定技术创新攻关和推广服务内容。每个农业科技专家服务团每年开展技术创新2项以上，开展技术推广服务30天以上，开展主导产业培训1000人次以上。
                          </div>
                      </div>
                      <div class="des">
                          <div class="title">四、推进科技示范基地建设</div>
                          <div >
                            联合有基础、有条件、有积极性的新型农业经营主体，共同打造集中连片300亩以上的科技示范基地1个以上，在其中示范推广新品种、新技术、新装备和新模式3个（项）以上。
                          </div>
                      </div>
                      <div class="des">
                          <div class="title">五、培育科技示范主体</div>
                          <div >
                            结合科技示范基地建设，在基地所在地的每村培育粮食生产科技示范户至少1户，由农业科技专家服务团提供技术指导。
                          </div>
                      </div>
                      <div class="des">
                          <div class="title">六、建立科技服务站点</div>
                          <div >
                            结合科技示范基地建设，在基地所在地的每村培育粮食生产科技示范户至少1户，由农业科技专家服务团提供技术指导。
                          </div>
                      </div>
                      <div class="des">
                          <div class="title">七、定期举办农技示范现场会</div>
                          <div >
                            结合农时和生产需求，定期开展新品种、新技术、新装备和新模式的示范现场会。开展科技服务供需对接活动和科技赶场活动，并通过各类媒体或渠道进行宣传推广。
                          </div>
                      </div>
                      <div class="des">
                          <div class="title">八、构建专业化社会化服务载体</div>
                          <div >
                            建立健全科技示范基地农机、植保、农资等社会化服务机制。位于粮油产业区的示范基地，应配套育秧中心、粮食烘干中心和综合农事服务中心。（结合“天府粮仓”成都片区建设任务）。
                          </div>
                      </div>
                      <div class="des">
                          <div class="title">九、培育粮油产品品牌</div>
                          <div >
                            积极开展绿色、有机和地理标志粮油产品认证，创建地方区域公共品牌，带动新型农业经营主体打造粮油特色品牌。每个区（市）县打造1-3个粮油产品品牌。（结合“天府粮仓”成都片区建设任务）。
                          </div>
                      </div>
                  </div>
              </div>

              <div class="gmlc">
                  <img
                      class="top"
                      src="./../assets/imgs/133/title3.png"
                      alt=""
                  />
                  <div class="content">
                    <div class="circle-box">
                      <div class="circle"></div>
                      <div class="circle-txt">
                        按照市级“备案制”管理模式，做好项目实施方案编制、审批、备案工作。
                      </div>
                    </div>
                      <div class="des mar-t3">
                          <div class="line-item">
                              <div class="line"></div>
                              <div class="line-top">
                                  <div class="line-num">1</div>
                                  <div class="line-title">编制方案</div>
                              </div>
                              <div class="line-content">
                                各区（市）县农业农村主管部门会同首席专家商议组建农业科技专家服务团，明确团队成员名单、服务内容、服务方式、绩效要求等事项，编制项目实施方案。
                              </div>
                          </div>
                          <div class="line-item">
                              <div class="line"></div>
                              <div class="line-top">
                                  <div class="line-num">2</div>
                                  <div class="line-title">县级审批</div>
                              </div>
                              <div class="line-content">
                                项目实施方案经区（市）县农业农村部门党组审核通过，以区（市）县农业农村部门名义申请市级核准备案。
                              </div>
                          </div>

                          <div class="line-item">
                              <div class="line-top">
                                  <div class="line" style="height: 140%;"></div>
                                  <div class="line-num">3</div>
                                  <div class="line-title" style="text-wrap: nowrap;">核准备案</div>
                              </div>
                              <div class="line-content">市农业农村局按照有关专项资金项目评审工作管理办法，组织专家对项目备案材料进行核查，核查通过后，以正式文件下达核准备案通知到各区（市）县。</div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="zccl" style="margin-top: 0.8rem;">
                  <img
                      class="top"
                      src="./../assets/imgs/133/title4.png"
                      alt=""
                  />
                  <div class="content" style="background-color: #fff;">
                    每个服务团给予最高30万元补助。
                  </div>
              </div>
              <div class="zccl">
                  <img
                      class="top"
                      src="./../assets/imgs/133/title5.png"
                      alt=""
                  />
                  <div class="content" style="background-color: #fff;font-weight: bolder;">
                    按相关通知要求进行。
                  </div>
              </div>
              <div class="contact" style="margin-top: 0.3rem">
                  <img
                      class="top"
                      src="./../assets/imgs/133/title6.png"
                      alt=""
                  />
                  <div class="content">
                      <div class="number">
                          <span class="label">政策咨询电话：</span>
                          <div>
                              <a href="tel:028-61883616">028-61883616</a>
                          </div>
                      </div>
                      <div class="unit">
                          <span class="label">责任单位：</span>
                          成都市农业农村局
                      </div>
                  </div>
              </div>
              <!-- <div class="codes">
                  <img class="info" src="../assets/imgs/133/code.png" />
              </div> -->
          </div>
      </section>
      <call phone="028-61883616"></call>
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
      return {};
  },

  components: {
      call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
  background-color: $base-back;
  padding-top: 0.3rem;

  .top-img {
      width: 7.26rem;
      height: 5.6rem;
  }

  .technological-process {
      transform: translateY(-1.9rem);

      .rhtj {
          position: relative;

          .top {
              width: 6.86rem;
              height: 1.12rem;
          }

          .content {
              width: 6.85rem;
              margin: -0.45rem auto 0;
              padding: 0.33rem;
              box-sizing: border-box;
              border-radius: 0rem 0rem 0.26rem 0.26rem;
              background: #ffffff;
              font-size: 0.26rem;
              color: #4e4e4e;
              text-align: left;
              position: relative;
              font-weight: 500;
              line-height: 0.44rem;
          }
      }

      .zccl {
          position: relative;
          margin-top: 0.22rem;

          .top {
              width: 7.03rem;
              height: 1.37rem;
              margin-left: -0.18rem;
          }

          .content {
              width: 6.85rem;
              background: #e8eeff;
              margin: -0.45rem auto 0;
              padding: 0.33rem;
              box-sizing: border-box;
              border-radius: 0rem 0rem 0.26rem 0.26rem;
              padding-top: 0.28rem;
              font-size: 0.26rem;
              font-weight: 500;
              text-align: left;
              color: #4e4e4e;
              line-height: 0.44rem;

              .des {
                  color: #4e4e4e;
                  text-align: left;
                  background: #ffffff;
                  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                  padding: 0.35rem 0.23rem 0.3rem;
                  margin-top: 0.8rem;
                  position: relative;
                  text-align: left;

                  .title {
                      position: absolute;
                      top: -0.5rem;
                      left: 50%;
                      transform: translateX(-50%);
                      width: 4.86rem;
                      height: 0.67rem;
                      line-height: 0.67rem;
                      display: flex;
                      justify-content: center;
                      align-content: center;
                      font-size: 0.32rem;
                      font-weight: bold;
                      color: #ffffff;
                      border-radius: 1rem;
                      background-color: #739bfe;
                  }
              }
          }
      }

      .gmlc {
          position: relative;
          margin-top: 0.22rem;

          .top {
              width: 7.03rem;
              height: 1.37rem;
              margin-left: -0.18rem;
          }

          .content {
              width: 6.86rem;
              background: #e8eeff;
              margin: -0.55rem auto;
              padding: 0 0.33rem 0.35rem 0.36rem;
              box-sizing: border-box;
              border-radius: 0rem 0rem 0.26rem 0.26rem;

              .circle-box {
                font-size: 0.34rem;
                color: #333;
                font-weight: bold;
                padding-top: 0.5rem;
                text-align: left;
                position: relative;
                .circle {
                  width: 0.28rem;
                  height: 0.28rem;
                  border: 0.06rem solid #FF6D60;
                  border-radius: 50%;
                  flex-shrink: 0;
                  box-sizing: border-box;
                  position: absolute;
                  left: 0;
                  top: 0.62rem;
                  display: inline-block;
                }
                .circle-txt {
                  text-indent: 1.1em;
                }
              }

              .title {
                  font-size: 0.36rem;
                  font-weight: bold;
                  color: #333333;
                  text-align: left;
                  line-height: 0.5rem;
              }

              .des {
                  color: #4e4e4e;
                  text-align: left;
                  background: #ffffff;
                  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                  padding: 0.3rem 0.23rem;
                  font-size: 0.26rem;
                  font-weight: 500;
                  color: #4e4e4e;
                  line-height: 0.44rem;

                  .line-item {
                      font-size: 0.26rem;
                      position: relative;
                      z-index: 3;

                      .line {
                          position: absolute;
                          width: 0.02rem;
                          height: 130%;
                          border-left: 0.02rem dashed #739bfe;
                          left: 0.2rem;
                          z-index: 0;
                          //   background-color: #739bfe;
                      }

                      .line-title {
                          font-size: 0.3rem;
                          font-weight: bold;
                          color: #3d5aa3;
                      }

                      .line-top {
                          display: flex;
                          width: 4.4rem;
                          height: 0.55rem;
                          background-image: url(../assets/imgs/25/label.png);
                          background-size: 100% 100%;
                          z-index: 99;
                          display: flex;
                          align-items: center;
                          box-sizing: border-box;
                          padding-left: 0.1rem;

                          .line-num {
                              width: 0.44rem;
                              height: 0.44rem;
                              background: #fff;
                              color: #3d5aa3;
                              display: inline-flex;
                              border-radius: 50%;
                              justify-content: center;
                              align-items: center;
                              margin-right: 0.18rem;
                              position: relative;
                              z-index: 3;
                              display: flex;
                              align-items: center;
                              justify-content: center;
                              font-size: 0.28rem;
                              font-weight: bold;
                          }
                      }

                      .line-content {
                          //   border-left: 0.02rem dashed #739bfe;
                          padding-bottom: 0.32rem;
                          margin-left: 0.2rem;
                          padding-left: 0.32rem;
                          padding-top: 0.15rem;
                          word-break: break-all;
                          line-height: 0.44rem;
                      }
                  }
              }
          }
      }

      .codes {
          margin: 0 auto;
          margin-top: 0.25rem;
          width: 6.85rem;
          background: #fff;
          padding: 0.3rem;
          box-sizing: border-box;
          border-radius: 0.26rem;
          padding-top: 0.28rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .info {
            width: 100%;
            height: 100%;
          }
      }
  }
}
</style>
